module.exports = __webpack_public_path__ + "media/img/pages/companies/e+h-vertical-3586cded078f8043eca5dc6b57c9760b.png";